import { ContextType, useContext } from "react";

import { PearContext } from "../../contexts/pear";

export default function usePear(): ContextType<typeof PearContext> {
  return useContext(PearContext);
}
